var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C24.8366 0 32 7.16337 32 16C32 24.8366 24.8366 32 16 32C7.16337 32 0 24.8366 0 16C0 7.16337 7.16337 0 16 0ZM11.3002 9.96133C14.6355 9.96133 17.3389 12.6654 17.3389 16C17.3389 19.3346 14.6355 22.0387 11.3002 22.0387C7.96556 22.0387 5.26215 19.3346 5.26215 16C5.26215 12.6654 7.96556 9.96133 11.3002 9.96133ZM20.9622 10.4385C22.6499 10.4385 24.0175 12.9284 24.0175 16C24.0175 19.0716 22.6499 21.5615 20.9622 21.5615C19.2745 21.5615 17.9068 19.0716 17.9068 16C17.9068 12.9284 19.2745 10.4385 20.9622 10.4385ZM25.6739 10.9151C26.2613 10.9151 26.7378 13.1914 26.7378 16C26.7378 18.8086 26.2613 21.0849 25.6739 21.0849C25.0859 21.0849 24.6093 18.8086 24.6093 16C24.6093 13.1914 25.0859 10.9151 25.6739 10.9151Z",
    fill: "#6E7E9D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.33b0be74835c05dd911128d6bacd64fc.svg";
export { ForwardRef as ReactComponent };